import api from './api';
import { CPB_URL } from './servers';

export const fetchCatalogos = (data) => api.post(`${CPB_URL}/catalogos/getCatalogos`, data);

export const fetchCatalogoMediosImpresos = () =>
  api.post(`${CPB_URL}/catalogos/getCatalogoMedidas`);

export const updateCatalogoMediosImpresos = (data) =>
  api.post(`${CPB_URL}/catalogos/sincronizarCatalogoMedidas`, data);

export const fetchCatalogoFechas = (data) =>
  api.post(`${CPB_URL}/catalogos/getCatalogoPeriodos`, data);

export const updateCatalogoFechas = (data) =>
  api.post(`${CPB_URL}/catalogos/sincronizarCatalogoPeriodos`, data);

/// Consulta de catálogos para descarga pública
export const fetchCatProcesosPublico = () =>
  api.post(`${CPB_URL}/catalogosIndividuales/getProcesosPublico`, {});

export const fetchCatsFiltrosPublico = (data) =>
  api.post(`${CPB_URL}/catalogosIndividuales/getFiltrosPublico`, data);

export const fetchCatEstadosPublico = (data) =>
  api.post(`${CPB_URL}/catalogosIndividuales/getEntidadesPublico`, data);

export const fetchCatBeneficiadosPublico = (data) =>
  api.post(`${CPB_URL}/catalogosIndividuales/getBeneficiadosPublico`, data);

export const fetchCatTiposMonitoreo = (data) =>
  api.post(`${CPB_URL}/catalogosIndividuales/getCMonitoreosPublico`, data);

export const fetchCatTiposHallazgo = (data) =>
  api.post(`${CPB_URL}/catalogosIndividuales/getHallazgosPublico`, data);

export const fetchPublicDownloads = (data) =>
  api.post(`${CPB_URL}/consultaPublica/getConsulta`, data);

/// Consulta de catálogos para beneficiados

export const fetchCatBenficiados = (data) =>
  api.post(`${CPB_URL}/catalogosIndividuales/getBeneficiados`, data);
